window.onstorage = (e) => {
	// Leave this empty
	// workaround for IE11 localstorage synchronization problem.
	// the event
	const tt = 1 + 1;
};
